import React from 'react';
import type { SubtitleProps } from './types';

const Subtitle = ({ src, label, srcLang, active = false }: SubtitleProps) => (
  <track role="track" label={label} srcLang={srcLang} src={src} default={active} kind="subtitles" />
);

export default Subtitle;
